<div [formGroup]="formGroup" *ngIf="formGroup" class="w-full py-2">
  <div
    class="grid grid-cols-12 gap-4 rounded-lg w-full max-w-md items-start mb-1"
  >
    <!-- Label -->
    <div class="col-span-3 md:col-span-6">
      <label
        [ngClass]="{ required: fields.isRequired == true }"
        class="block text-2sm font-medium text-gray-900 mt-1"
      >
        {{ fields.displayName }}
      </label>
    </div>

    <!-- Input + Error -->
    <div class="col-span-9 md:col-span-6">
      <div class="flex flex-col w-full">
        <input
          #focusInput
          type="text"
          [formControlName]="fields.fieldName"
          [placeholder]="fields.placeholder"
          #inputRef
          (keyup)="onKeyUpValidateFields(fields)"
          (input)="addDomainFromControl(inputRef)"
          class="input rounded-md px-4 py-2 text-2sm w-full"
        />
        <span class="text-gray-500 text-2sm">{{ fields.helpText }}</span>

        <!-- Error -->
        <span *ngIf="showError" class="text-danger text-sm mt-1 leading-tight">
          {{ showError }}
        </span>
      </div>
    </div>
  </div>
</div>
